import React from 'reactn';
import { UnidadBase } from './UnidadBase.atomo';
export const UnidadLibras = (props, column) => <UnidadBase {...props} column={column} claseExtra="unidad-kg-bold" unidad="lb"/>;